const palette = {
  text: {
    primary: '#6c6d6d',
    secondary: '#424242',
  },
  primary: {
    light: '#5d8aff',
    main: '#005ECE',
    dark: '#00369c',
    contrastText: '#fff',
  },
  secondary: {
    light: '#6affff',
    main: '#00d9ef',
    dark: '#00a7bc',
    contrastText: '#fff',
  },
};

export default palette;
